import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ModalWizard from "./ModalWizard";
import Modal from "../common/Modal";
import { useAuth } from "../../hooks/useAuth";

function OrdersWizardDemoLauncher({ close }) {
  const { auth, setAuth } = useAuth();
  const { t } = useTranslation();

  const [showWizard, setShowWizard] = useState(false);
  const authBackupRef = useRef();

  const selectUserType = (e, userType) => {
    e.stopPropagation();
    authBackupRef.current = JSON.parse(JSON.stringify(auth));
    const authTemp = userType.getSimulatedAuth();
    const mergedAuth = {
      ...auth,
      ...authTemp.auth,
    };
    setAuth({ ...mergedAuth });
    setShowWizard(true);
  };

  const closeWizard = () => {
    setShowWizard(false);
    if (authBackupRef.current) {
      setAuth(authBackupRef.current);
      authBackupRef.current = null;
    }
  };

  return (
    <>
      <Modal show={true} close={() => close()} title={t("wizard.demo.selectUserType")} size="medium">
        <div className="wizard-demo-selector">
          <p className="mb-20">{t("wizard.demo.description")}</p>
          {USER_TYPES.map((userType) => (
            <div key={userType.id} className="wizard-demo-option" onClick={(e) => selectUserType(e, userType)}>
              <i className="notranslate material-icons-outlined">{userType.icon}</i>
              <div>
                <h4>{t(userType.titleKey)}</h4>
                <p className="meta">{t(userType.descriptionKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </Modal>

      {showWizard && <ModalWizard close={closeWizard} isDemoMode={true} />}
    </>
  );
}

export default OrdersWizardDemoLauncher;

const USER_TYPES = [
  {
    id: "provider",
    icon: "medical_services",
    titleKey: "wizard.demo.providerTitle",
    descriptionKey: "wizard.demo.providerDescription",
    getSimulatedAuth: () => ({
      auth: {
        user: {
          role: "supervisor",
          groups: ["supervisor", "doctor"],
          firstName: "Demo",
          lastName: "Provider",
          custom: {
            doctorConsentAuthorizeVersion: "demo",
          },
        },
        session: {
          currentOrganizationPlan: "order-provider",
        },
        brain: { variables: {} },
      },
    }),
  },
  {
    id: "sales-rep",
    icon: "attach_money",
    titleKey: "wizard.demo.salesRepTitle",
    descriptionKey: "wizard.demo.salesRepDescription",
    getSimulatedAuth: () => ({
      auth: {
        user: {
          role: "advanced",
          groups: ["sales-rep"],
          firstName: "Demo",
          lastName: "SalesRep",
          custom: {
            doctorConsentAuthorizeVersion: "demo",
          },
        },
        session: {
          currentOrganizationPlan: "order-manufacturer",
        },
        brain: { variables: {} },
      },
    }),
  },
  {
    id: "manufacturer",
    icon: "business",
    titleKey: "wizard.demo.manufacturerTitle",
    descriptionKey: "wizard.demo.manufacturerDescription",
    getSimulatedAuth: () => ({
      auth: {
        user: {
          role: "supervisor",
          groups: ["team-member"],
          firstName: "Demo",
          lastName: "Manufacturer",
          custom: {
            doctorConsentAuthorizeVersion: "demo",
          },
        },
        session: {
          currentOrganizationPlan: "order-manufacturer",
        },
        brain: {
          variables: {
            ordersManagement: "true",
          },
        },
      },
    }),
  },
];
